import { TreeNode } from 'primeng/api';
import { Periodicity } from './Handbooks/Periodicity';
import { Industry } from './Industry';
import { Activity } from './Handbooks/Activity';
import { MeasureUnit } from './Handbooks/MeasureUnit';
import { SourceSystem } from './Handbooks/SourceSystem';
import { InformationSource } from './Handbooks/InformationSource';

/**
 * Индикатор
 * Indicator
 */
export class Indicator {
    
    /**
     * Первичный ключ
     * Primary key
     */
    Id: number = 0;
    /**
     * Идентификатор типа активной области
     * Activity type identifier
     */
    ActivityId: number = 0;
    /**
     * Тип активной области
     * Activity type
     */
    Activity: Activity = null;
    /**
     * Идентификатор индустрии
     * Industry identifier
     */
    IndustryId: number = 0;
    /**
     * Индустрия
     * Industry
     */
    Industry: Industry = null;

    IndustryTreeSelected: TreeNode = {};

    /**
     * Идентификатор периодичности этого индикатора
     * Periodicity identifier of this indicator
     */
    PeriodicityId: number = 0;
    /**
     * Периодичность
     * Periodicity
     */
    Periodicity: Periodicity = null;

    /**
     * Идентификатор единицы измерения этого индикатора
     * Measure unit identifier of this indicator
     */
    MeasureUnitId: number = 0;
    /**
     * Единица измерения
     * Measure unit
     */
    MeasureUnit: MeasureUnit = null;

    /**
     * Список идентификаторо связанных документов
     * List of referenced documents identifiers
     */
    ReferencedDocumentsIds: Array<number> = [];

    ReferencedDocumentsIdsString: string = '';

    /**
     * Идентификатор системы-источника этого индикатора
     * Source system identifier of this indicator
     */
    SourceSystemId: number = 0;
    /**
     * Система-источник
     * Source system
     */
    SourceSystem: SourceSystem = null;

    /**
     * Идентификатор источника информации этого индикатора
     * Information source identifier of this indicator
     */
    InformationSourceId: number = 0;
    /**
     * Источник информации
     * Information source
     */
    InformationSource: InformationSource = null;

    /**
     * Идентификатор соответствующего индикатора из системы Талдау
     * Corresponding indicator identifier form Taldau system
     */
    TaldauIdentifier: string = '';

    //#region
    /**
     * Наименование индикатора на русском языке
     * Indicator name in russian
     */
    NameRu: string = '';
    /**
     * Наименование индикатора на казахском языке
     * Indicator name in kazakh
     */
    NameKz: string = '';
    /**
     * Наименование индикатора на английском языке
     * Indicator name in english
     */
    NameEn: string = '';
    /**
     * Альтернативное наименование индикатора на русском языке
     * Indicator alternative name in russian
     */
    AlternativeNameRu: string = '';
    /**
     * Альтернативное наименование индикатора на казахском языке
     * Indicator alternative name in kazakh
     */
    AlternativeNameKz: string = '';
    /**
     * Альтернативное наименование индикатора на английском языке
     * Indicator alternative name in english
     */
    AlternativeNameEn: string = '';
    /**
     * Комментарий индикатора на русском языке
     * Indicator comment in russian 
     */
    CommentRu: string = '';
    /**
     * Комментарий индикатора на казахском языке
     * Indicator comment in kazakh 
     */
    CommentKz: string = '';
    /**
     * Комментарий индикатора на английском языке
     * Indicator comment in english 
     */
    CommentEn: string = '';
    //#endregion

    //#region Flags
    /**
     * Доступно ли плановое значение для показателей этого индикатора?
     * Is planned value available for this indicator's factors?
     */
    IsPlannedAvailable: boolean = false;
    /**
     * Является ли этот индикатор позитивным?
     * Is this indicator positive?
     */
    IsPositive: boolean = true;
    /**
     * Является ли этот идентификатор верифицированным?
     * Is this indicator verified?
     */
    IsVerified: boolean = false;
    /**
     * Является ли этот индикатор устаревшим?
     * Is this indicator obsolete?
     */
    IsObsolete: boolean = false;
    //#endregion

    /**
     * Минимально логически допустимое значение индикатора
     * Logicaly minimal value of indicator
     */
    MinValue: number = 0.0;
    /**
     * Максимально логически допустимое значение индикатора
     * Logicaly maximal value of indicator
     */
    MaxValue: number = 0.0;
    /**
     * Разделен ли индикатор по районам?
     * Is this indicator devided by regions
     */
    IsDeviedByRegions: boolean = false;
    /**
     * Является ли этот индикатор доступным публично?
     * Is this indicator is publicly available?
     */
    IsPublic: boolean = false;
}

function Ref(input: Industry, child: any): any {
    var _node = {
        label: input.Name,
        data: input,
        children: child != null ? [child] : []
    }
    if (input.Parent != null) {
        return Ref(input.Parent, _node)
    }
    return _node;
}